import { pickBy as _pickBy } from 'lodash';
import { convertToInt } from './helpers';

export const getUserIdFromUrl = () => {
  const regex = /client\/(\d+)/;
  const regexMatch = window.location.hash.match(regex);

  if (regexMatch) {
    const id = regexMatch[1];
    return convertToInt(id);
  }

  return null;
};

export const redirectCurrentHostToClient = userId => {
  window.location.href = `/#/client/${userId}`;
};

export const redirectToLogin = () => {
  window.location.href = '/#/login';
  window.location.reload(true);
};
export const redirectToForgotPassword = () => {
  window.location.href = '/#/forgot-password';
};

export const buildQueryString = params => {
  // Remove keys with '', null, or undefined values
  const nonEmptyParams = _pickBy(params, value => value !== '' && value != null);

  const searchParams = new URLSearchParams(nonEmptyParams);
  const queryString = searchParams.toString();

  return queryString
    ? '?' + queryString
    : '';
};
